export enum SignalFxFEPerfStore {
  FE_USER_TASK_CHANGE_SUB_TIME = 'fe.user.task.change.subscription.time',
  FE_USER_TASK_CANCEL_SUB_TIME = 'fe.user.task.cancel.subscription.time',
  FE_USER_TASK_SET_BILL_DATE_TIME = 'fe.user.task.set.billdate.time',
  FE_USER_TASK_SWITCH_TO_ANNUAL_BILLING_TIME = 'fe.user.task.switch.to.annual.billing.time',
  FE_USER_TASK_SWITCH_BILLING_PROFILE_TIME = 'fe.user.task.switch.billing.profile.time',
  FE_USER_TASK_REWIND_TIME = 'fe.user.task.rewind.time',
  FE_USER_TASK_ADD_PROMO_TIME = 'fe.user.task.add.prmotions.time',
  FE_USER_TASK_REMOVE_PROMO_TIME = 'fe.user.task.remove.promotions.time',
  FE_USER_TASK_SUB_TO_ADDON_TIME = 'fe.user.task.sub.to.add.on.time',
}
